import { dateFormat } from "@jumbo/utils/shamsiStandardFormat";
import {
  SET_FORM_SETTINGS,
  ADD_FORM_FIELD,
  REMOVE_FORM_FIELD,
  SET_FORM_FIELDS,
  SET_EDITING_FIELD,
  SET_ALL_FORMS,
  SET_FORMS_TOTAL_PAGES,
  SET_FORMS_CURRENT_PAGE,
  DELETE_FROM_FIELD,
  SET_SINGLE_FORM,
  SET_CURR_SETTINGS,
  SET_FILL_FORMS,
  FILL_FORMS_TOTAL_PAGES,
  ACCESS_LIST_CURRENT_PAGE,
  REMOVE_SINGLE_FORM_FILL,
  SET_SINGLE_FORM_FILL,
  FORM_INPUT_SEARCH,
  FILL_FORM_TOTAL_DOCS,
  ADD_FORM_FIELD_AT_INDEX
} from "../../@jumbo/constants/ActionTypes";

const INIT_STATE = {
  allForms: [],
  form: null,
  formCurrentPage: 0,
  formsTotalPages: 0,
  formSettings: {
    formId: "",
    formTitle: "",
    formSubTitle: "",
    formIcon: "",
    formPoster: "",
    formDesc: "",
    formType: "",
    formLimit: false,
    limitCount: 0,
    hasDateLimit: false,
    startDate: dateFormat,
    endDate: dateFormat,
    accessList: false,
    accessListTopic: "",
    accessListType: "",
    blackAccessList: false,
    blackAccessListTopic: "",
    blackAccessListType: "",
    blackAccessListError: "",
    confirmation: "",
    family: false,
    removable: false,
    active: false,
    archived: false,
    privacyMode: false,
    customSMSMessageEnabled: false,
    customSMSMessage: "",
    customFormMessageEnabled: false,
    customFormMessage: "",
    maxQuestions: 0,
    durationEnabled: false,
    durationMinutes: 1,
  },
  formFields: [],
  editingField: "",
  currSettings: "GENERAL",
  fillForms: [],
  fillForm: null,
  fillFormCurrentPage: 0,
  fillFormTotalPages: 0,
  fillFormTotalDocs: 0,
  formInputSearch: "",
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_CURR_SETTINGS: {
      return {
        ...state,
        currSettings: action.payload,
      };
    }
    case SET_FORM_SETTINGS: {
      return {
        ...state,
        formSettings: action.payload,
      };
    }
    case SET_SINGLE_FORM: {
      return {
        ...state,
        form: action.payload,
      };
    }
    case SET_FORM_FIELDS: {
      return {
        ...state,
        formFields: action.payload,
      };
    }
    case ADD_FORM_FIELD: {
      return {
        ...state,
        formFields: [...state.formFields, action.payload],
      };
    }
    case ADD_FORM_FIELD_AT_INDEX: {
      const { index, field } = action.payload;
    
      return {
        ...state,
        formFields: [
          ...state.formFields.slice(0, index),
          field,
          ...state.formFields.slice(index),
        ],
      };
    }
    case SET_EDITING_FIELD: {
      return {
        ...state,
        editingField: action.payload,
      };
    }
    case REMOVE_FORM_FIELD: {
      return {
        ...state,
        formFields: state.formFields.filter(
          (item) => (item._id || item.id) !== action.payload
        ),
      };
    }
    case SET_ALL_FORMS: {
      return {
        ...state,
        allForms: action.payload,
      };
    }
    case SET_FORMS_TOTAL_PAGES: {
      return {
        ...state,
        formsTotalPages: action.payload,
      };
    }
    case SET_FORMS_CURRENT_PAGE: {
      return {
        ...state,
        formCurrentPage: action.payload,
      };
    }
    case SET_FILL_FORMS: {
      return {
        ...state,
        fillForms: action.payload,
      };
    }
    case FILL_FORMS_TOTAL_PAGES: {
      return {
        ...state,
        fillFormTotalPages: action.payload,
      };
    }
    case FILL_FORM_TOTAL_DOCS: {
      return {
        ...state,
        fillFormTotalDocs: action.payload,
      };
    }
    case ACCESS_LIST_CURRENT_PAGE: {
      return {
        ...state,
        fillFormCurrentPage: action.payload,
      };
    }
    case REMOVE_SINGLE_FORM_FILL: {
      const toBeRemovedId = action.payload;
      const formfilledCopy = [...state.fillForms];
      if (formfilledCopy.lenght !== 0) {
        formfilledCopy.forEach((item, index) => {
          if (item._id === toBeRemovedId) {
            formfilledCopy.splice(index, 1);
          }
        });
      }
      return {
        ...state,
        fillForms: formfilledCopy,
      };
    }
    case DELETE_FROM_FIELD: {
      return {
        ...state,
        allForms: state.allForms.filter(
          (item) => (item._id || item.id) !== action.payload
        ),
      };
    }
    case SET_SINGLE_FORM_FILL: {
      return {
        ...state,
        fillForm: action.payload,
      };
    }
    case FORM_INPUT_SEARCH: {
      return {
        ...state,
        formInputSearch: action.payload,
      };
    }
    default:
      return state;
  }
};
